// „Коригирай общото": операторът пише в реда „Общо" сумата от хартията
// (48.00), а сборът на редовете е друг (47.98) — разликата, обикновено
// стотинки закръгляне, отива в реда с НАЙ-ГОЛЯМА сума в тази колона като
// въведена сума (`typedSum`), така че цената му се извежда от нея, а
// записаното общо е точно въведеното. Чиста функция, без React.
import { parseDecimal, roundMoney } from "../../components/numbers";
import { formatLineSum } from "./deliveryRowMath";
import type { DeliveryRowDraft } from "./deliveryWorksheetShared";

export type TotalColumn = "net" | "gross";

export type TotalAdjustPlan =
  // въведеното съвпада със сбора — нищо за правене
  | { kind: "none" }
  // няма ред с количество и сума, който да поеме разликата
  | { kind: "noRows" }
  // редът би станал ≤ 0 — разликата не е закръгляне
  | { kind: "tooLarge"; productId: number; delta: number }
  | { kind: "apply"; productId: number; value: string; delta: number };

// Над тази разлика вече не е закръгляне — листът пита, преди да я сложи
export const TOTAL_ADJUST_CONFIRM_ABOVE = 1;

// `entries` — редовете в реда на таблицата (при равни суми печели по-горният);
// `current` — показаното общо (със стоковите на фактурата, ако има).
export const planTotalAdjust = (
  entries: [number, DeliveryRowDraft][],
  column: TotalColumn,
  target: number,
  current: number,
): TotalAdjustPlan => {
  const delta = roundMoney(target - current);
  if (Math.abs(delta) < 0.005) return { kind: "none" };
  const candidates = entries.filter(
    ([, row]) => parseDecimal(row.qty) > 0 && parseDecimal(row[column]) > 0,
  );
  if (!candidates.length) return { kind: "noRows" };
  const [productId, row] = candidates.reduce((best, entry) =>
    parseDecimal(entry[1][column]) > parseDecimal(best[1][column]) ? entry : best,
  );
  const next = roundMoney(parseDecimal(row[column]) + delta);
  if (next <= 0) return { kind: "tooLarge", productId, delta };
  return { kind: "apply", productId, value: formatLineSum(next), delta };
};

// „+0.02" / „−0.02" — за бележката под реда и за въпроса
export const formatSignedDelta = (delta: number) =>
  `${delta > 0 ? "+" : "−"}${Math.abs(delta).toFixed(2)}`;
